import { render, staticRenderFns } from "./AdminVouchersPage.vue?vue&type=template&id=36c6d3fc&"
import script from "./AdminVouchersPage.vue?vue&type=script&lang=js&"
export * from "./AdminVouchersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports